import React from 'react'
import PropTypes from 'prop-types'

import { onEnter } from '../../../utilities/accessibility/onEnter'
import '../../../styles/scss/filters/dismissable-list-filter-tab.scss'

const DismissableListFilterTab = ({ label, onClick }) => {
  return (
    <div
      aria-label={label}
      className="dismissable-list-filter-tab"
      id="list-filter-tab"
      onClick={onClick}
      onKeyDown={event => onEnter(event, onClick)}
      role="button"
      tabIndex="0"
    >
      <span>{label}</span>
    </div>
  )
}

DismissableListFilterTab.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default DismissableListFilterTab
